import { twMerge } from 'tailwind-merge';

import { AppStoreButtons } from '../../../../../Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { QRCode } from '../../../../../QRCode/QRCode';

interface MoreContentOptionsProps {
  className?: string;
}

export const MoreContentOptions = ({ className }: MoreContentOptionsProps) => {
  return (
    <section className={twMerge('w-full', className)}>
      <div className="flex flex-col items-center justify-center gap-2 p-2 md:flex-row">
        <QRCode className="bg-sea-foam rounded-md p-2" source="RegistryWall" />
        <AppStoreButtons orientation="vertical" source="RegistryWall" />
      </div>
    </section>
  );
};
